import React, { useEffect, useState, useImperativeHandle } from "react";
import "./styles.scss";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import Rows from "./DnDTables/SO";

import { useDidMountEffect } from "util";

const SOTable = (props, _ref) => {
    const { onChg, cycle,onOpen,soSelected,setSoSelected,handleClickSQTable,RevCmptCheckList } = props;
    const [_tblData, _setTblData] = useState([]);
    const [_isTblData, _setIsTblData] = useState(false);
    const [temp, setTemp] = useState([]);




    useImperativeHandle(_ref, () => ({
        setData: (data) => {
            _setTblData((d) => [...data]);
            setTemp((d) => [...data]);
        },
        preOnData: ({data}) =>{
            _setTblData(data);
        },
        resetData: () =>{
            _setTblData(temp);
        },
    }));

    useDidMountEffect(() => {
        // console창에 경고문 뜨는거 해결
        if (_isTblData) {
            onChg(_tblData);
            _setIsTblData(!_isTblData);
        } else {
            seqCodeAlgorithm(); // 코드 넣기 추기
            _setIsTblData(!_isTblData);
        }
        // seqCodeAlgorithm(); // 코드 넣기 추기
        // onChg(_tblData);
    }, [_tblData, cycle]);

    // seqCode 부여 logic
    const seqCodeAlgorithm = () => {
        // Temp Save 모드 값이 불려오지는 것으로 그대로 출력
        // _setTblData((T) => {
        //     return T.map((d) => {
        //         return { ...d, timeStamp: Date.parse(new Date()) };
        //     });
        // });
        let array = [];
        let seqCode = -1;
        let startY = 0;
        let endY = startY;
        let isFlag = false;
        // debugger
        for (let i = 0; i <= _tblData.length; i++) {
            // debugger
            if (!(i === _tblData.length) && _tblData[i].repeat === "Y") {
                isFlag = true;
                endY++;
            } else {
                // 반복 시 startY, endY까지 찍는다.
                if (isFlag) {
                    let arrayTemp = new Array(endY - startY).fill("");
                    for (let initRepeat = 0; initRepeat < cycle; initRepeat++) {
                        // debugger
                        let indexY = 0;
                        // ('S'+('00' + (seqCode)).slice(-2));
                        for (let y = startY; y < endY; y++) {
                            seqCode++;
                            if (initRepeat === cycle - 1) {
                                arrayTemp[indexY++] += "S" + ("00" + seqCode).slice(-2);
                            } else {
                                arrayTemp[indexY++] += "S" + ("00" + seqCode).slice(-2) + ", ";
                            }
                            // Y 값
                        }
                    }
                    arrayTemp.map((arr) => {
                        array.push(arr);
                    });
                    seqCode++;
                    array.push("S" + ("00" + seqCode).slice(-2));
                } else if (startY === 0) {
                    seqCode++;
                    array.push("S" + ("00" + seqCode).slice(-2));
                } else {
                    if (i === _tblData.length) continue;
                    seqCode++;
                    array.push("S" + ("00" + seqCode).slice(-2));
                }
                isFlag = false;
                startY = i + 1;
                endY = startY;
            }
        }
        _setTblData((T) => {
            return T.map((d, i) => {
                return {
                    ...d,
                    seqCode: array[i],
                };
            });
        });
    };
    const onOpenWrapper = (vv,uniqueCode) => {
        onOpen(vv,uniqueCode,_tblData,'SO');
    }
    if (_tblData.length > 0)
        return (
            <DndProvider backend={HTML5Backend}>
                <table id="so-table">
                    <colgroup>
                        <col width="40px" />
                        <col width="10%" />
                        <col width="20%" />
                        <col />
                        <col width="60px" />
                        <col width="1px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>Seq</th>
                            <th>Code</th>
                            <th>Step Operation</th>
                            <th>Description</th>
                            <th>Repeat</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {_tblData.map((v, i) => {
                            return <Rows index={i}
                                         rowData={v}
                                         key={"detailSO" + i}
                                         onOpen = {onOpenWrapper}
                                         dataIndex={i}
                                         sheetType={"S"}
                                         soSelected = {soSelected}
                                         handleClickSQTable = {handleClickSQTable}
                                         RevCmptCheckList = {RevCmptCheckList}
                                    />;
                        })}
                    </tbody>
                </table>
            </DndProvider>
        );
    else return null;
};

export default React.forwardRef(SOTable);
